import type { RequestFn } from '../http';

export interface DiagnosisSuggestion {
  id: string;
  submissionId: string;
  ticketId: number | null;
  summary: string;
  solution: string;
  similarityScore: number;
  resolvedAt: string;
}

export function createDiagnoseApi(request: RequestFn) {
  return {
    /**
     * Findet ähnliche bereits gelöste Probleme basierend auf Symptom
     */
    async suggestSimilarProblems(data: {
      symptom: string;
      limit?: number;
      minSimilarity?: number;
    }) {
      const params = new URLSearchParams();
      params.set('symptom', data.symptom);
      if (data.limit) params.set('limit', String(data.limit));
      if (data.minSimilarity) params.set('minSimilarity', String(data.minSimilarity));

      return request<{
        symptom: string;
        suggestions: DiagnosisSuggestion[];
        count: number;
      }>(`/diagnose/suggest?${params.toString()}`);
    },

    /**
     * Speichert Feedback über die Nützlichkeit von Suggestions
     */
    async recordDiagnosisFeedback(data: {
      submissionId: string;
      symptomText: string;
      suggestedSubmissionId?: string;
      helpful: boolean;
      comment?: string;
    }) {
      return request<{
        success: boolean;
        message: string;
      }>('/diagnose/feedback', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },
  };
}
